/* eslint-disable react/prop-types */ // TODO: add props
import { useState } from 'react';
import styles from './styles.scss';
import { Link } from 'react-router-dom';

const NUMBER_OF_NAMES_TO_SHOW_WITHOUT_EXPANDING = 4;

const NotAnsweredStudentNames = ({ studentNames }) => {
  const [expanded, setExpanded] = useState(false);
  const studentNamesToShow = expanded
    ? studentNames
    : studentNames.slice(0, NUMBER_OF_NAMES_TO_SHOW_WITHOUT_EXPANDING);

  const remainingCount =
    studentNames.length - NUMBER_OF_NAMES_TO_SHOW_WITHOUT_EXPANDING;

  return (
    <div className={styles.notAnsweredStudentNames}>
      {studentNamesToShow.join(', ')}
      {!expanded && remainingCount > 0 && (
        <span>
          {', and '}
          <Link className={styles.link} onClick={() => setExpanded(!expanded)}>
            {`${remainingCount} others`}
          </Link>
        </span>
      )}
      {expanded && (
        <>
          &nbsp;
          <Link
            className={styles.otherNamesLink}
            onClick={() => setExpanded(!expanded)}
          >
            show less
          </Link>
        </>
      )}
    </div>
  );
};

export default NotAnsweredStudentNames;
